import { computed } from 'mobx';

import { POLICY_APPLICATIONS, EVENT_POLICY_METRICS } from '@kentik/ui-shared/alerting/constants';
import { isSyslogEventPolicy, isSnmpTrapEventPolicy } from 'app/stores/alerting/policyUtils';
import { TARGET_TYPES } from 'app/forms/config/unified/constants';
import FlowPolicyModel from '../FlowPolicyModel';

class EventPolicyModel extends FlowPolicyModel {
  constructor(attributes = {}, options = {}) {
    super({ ...attributes, application: POLICY_APPLICATIONS.KEVENT }, { deserialize: true, ...options });
  }

  get urlRoot() {
    return '/api/ui/alerting/policies/kevent';
  }

  @computed
  get isSyslogEventPolicy() {
    return isSyslogEventPolicy(this.dimensions);
  }

  @computed
  get isSnmpTrapEventPolicy() {
    return isSnmpTrapEventPolicy(this.dimensions);
  }

  get metrics() {
    if (this.isSyslogEventPolicy) {
      return [EVENT_POLICY_METRICS.SYSLOG];
    }

    if (this.isSnmpTrapEventPolicy) {
      return [EVENT_POLICY_METRICS.SNMP_TRAP];
    }

    return this.get('metrics');
  }

  // TODO: we do, but we shouldn't change this in FlowPolicyModel during serialization
  get userId() {
    return this.get('userID');
  }

  @computed
  get targetType() {
    return TARGET_TYPES.EVENT;
  }

  get filters() {
    return this.get('filters') || {};
  }

  clonePolicy(overrides = {}) {
    const { id, name, thresholds = [], activationSettings, rule, ...clonedPolicyAttrs } = this.get();
    const clonedPolicy = new this.constructor(clonedPolicyAttrs, { deserialize: false });
    const { ruleId, ...clonedActivationSettings } = activationSettings || {};

    clonedPolicy.set({
      name: `${name} (Clone)`,
      thresholds: thresholds.map(({ thresholdID, policyID, ...threshold }) => threshold),
      activationSettings: clonedActivationSettings,
      minTrafficValue: 0,
      status: 'active',
      ...overrides
    });

    return clonedPolicy;
  }

  /**
   * Override BasePolicyModel's getFormValues to apply kevent-specific transformations
   * (e.g. explorer policy hydration, clone detection) before returning form-ready values.
   */
  getFormValues() {
    return this.getPolicyFormValues();
  }

  getPolicyFormValues = () => {
    // Explorer path
    if (this.get('isExplorerPolicy')) {
      const { filters = {}, dimensions, eventType, ...rest } = this.get();

      return {
        ...rest,
        uiProperties: { eventType },
        dimensions,
        filters: { ...filters }
      };
    }

    return this.get();
  };
}

export default EventPolicyModel;
